(() => {
  const ROOT = '[data-isw-pure-v2]';

  function createYouTube(panel, autoplay) {
    const holder = panel.querySelector('[data-pure-youtube]');
    const id = panel.dataset.youtubeId;
    if (!holder || !id) return null;

    holder.querySelector('iframe')?.remove();

    const iframe = document.createElement('iframe');
    const query = autoplay
      ? `autoplay=1&mute=1&loop=1&playlist=${encodeURIComponent(id)}&controls=0&playsinline=1&rel=0`
      : `autoplay=1&controls=1&playsinline=1&rel=0`;

    iframe.src = `https://www.youtube.com/embed/${encodeURIComponent(id)}?${query}`;
    iframe.title = panel.querySelector('h3')?.textContent?.trim() || 'S7 feature video';
    iframe.allow = 'autoplay; encrypted-media; picture-in-picture';
    iframe.allowFullscreen = true;
    holder.appendChild(iframe);
    return iframe;
  }

  function stopMedia(panel) {
    panel.classList.remove('is-playing');

    const video = panel.querySelector('[data-pure-local-video]');
    if (video) {
      try {
        video.pause();
        video.controls = false;
        if (panel.dataset.playback === 'button') video.currentTime = 0;
      } catch (_) {}
    }

    if (panel.dataset.mediaType === 'youtube') {
      panel.querySelector('[data-pure-youtube] iframe')?.remove();
    }
  }

  function autoPlayActive(panel) {
    if (!panel.classList.contains('is-active')) return;
    if (panel.dataset.playback !== 'autoplay') return;

    if (panel.dataset.mediaType === 'local_video') {
      const video = panel.querySelector('[data-pure-local-video]');
      if (!video) return;
      video.muted = true;
      video.loop = true;
      video.playsInline = true;

      const tryPlay = () => {
        const promise = video.play();
        if (promise?.catch) promise.catch(() => {});
      };

      if (video.readyState >= 2) tryPlay();
      else video.addEventListener('canplay', tryPlay, { once:true });
    }

    if (panel.dataset.mediaType === 'youtube') {
      createYouTube(panel, true);
    }
  }

  function manualPlay(panel) {
    if (!panel.classList.contains('is-active')) return;

    if (panel.dataset.mediaType === 'local_video') {
      const video = panel.querySelector('[data-pure-local-video]');
      if (!video) return;

      panel.classList.add('is-playing');
      video.controls = true;
      video.muted = false;
      video.playsInline = true;

      const promise = video.play();
      if (promise?.catch) {
        promise.catch(() => {
          video.muted = true;
          video.play().catch(() => {});
        });
      }
    }

    if (panel.dataset.mediaType === 'youtube') {
      panel.classList.add('is-playing');
      createYouTube(panel, false);
    }
  }

  function init(section) {
    if (!section || section.dataset.pureV2Ready === 'true') return;
    section.dataset.pureV2Ready = 'true';

    const accordion = section.querySelector('[data-pure-accordion]');
    const panels = [...section.querySelectorAll('[data-pure-panel]')];
    const dots = [...section.querySelectorAll('[data-pure-dot]')];
    if (!accordion || !panels.length) return;

    let active = panels.findIndex(p => p.classList.contains('is-active'));
    if (active < 0) active = 0;
    active = Math.min(active, panels.length - 1);

    let sx = 0, sy = 0, pid = null, drag = false;

    function setActive(index) {
      index = Math.max(0, Math.min(panels.length - 1, index));
      active = index;

      panels.forEach((panel, i) => {
        const on = i === index;
        if (!on) stopMedia(panel);
        panel.classList.toggle('is-active', on);
        panel.tabIndex = on ? 0 : -1;
      });

      dots.forEach((dot, i) => dot.classList.toggle('is-active', i === index));
      autoPlayActive(panels[index]);
    }

    panels.forEach((panel, index) => {
      panel.querySelector('[data-pure-open]')?.addEventListener('click', () => setActive(index));

      panel.querySelector('[data-pure-play]')?.addEventListener('click', event => {
        event.preventDefault();
        event.stopPropagation();
        manualPlay(panel);
      });

      panel.addEventListener('keydown', event => {
        if (event.key === 'ArrowRight') {
          event.preventDefault();
          setActive(Math.min(panels.length - 1, active + 1));
        } else if (event.key === 'ArrowLeft') {
          event.preventDefault();
          setActive(Math.max(0, active - 1));
        }
      });
    });

    dots.forEach(dot => {
      dot.addEventListener('click', () => setActive(Number(dot.dataset.index || 0)));
    });

    accordion.addEventListener('pointerdown', event => {
      if (event.target.closest?.('[data-pure-play],video,iframe')) return;
      if (event.pointerType === 'mouse' && event.button !== 0) return;
      sx = event.clientX;
      sy = event.clientY;
      pid = event.pointerId;
      drag = false;
    });

    accordion.addEventListener('pointermove', event => {
      if (pid !== event.pointerId) return;
      const dx = event.clientX - sx;
      const dy = event.clientY - sy;
      if (Math.abs(dx) > 14 && Math.abs(dx) > Math.abs(dy)) drag = true;
    });

    accordion.addEventListener('pointerup', event => {
      if (pid !== event.pointerId) return;
      const dx = event.clientX - sx;
      if (drag && Math.abs(dx) > 42) setActive(active + (dx < 0 ? 1 : -1));
      pid = null;
      drag = false;
    });

    accordion.addEventListener('pointercancel', () => {
      pid = null;
      drag = false;
    });

    setActive(active);
  }

  function initAll(scope = document) {
    if (scope.matches?.(ROOT)) init(scope);
    scope.querySelectorAll?.(ROOT).forEach(init);
  }

  if (!window.__ISWS7PureFeaturesV2) {
    window.__ISWS7PureFeaturesV2 = { init:initAll };

    const boot = () => initAll(document);
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot, { once:true });
    } else {
      boot();
    }

    document.addEventListener('page:loaded', boot);
    document.addEventListener('shopify:section:load', e => initAll(e.target));
    document.addEventListener('shopify:section:unload', e => {
      e.target.querySelectorAll?.('[data-pure-panel]').forEach(stopMedia);
    });
  } else {
    window.__ISWS7PureFeaturesV2.init(document);
  }
})();
